var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"disabled":!_vm.contractor.path,"top":"","max-width":"300"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({class:{
                'tw-underline tw-decoration-dotted': _vm.contractor.path,
            }},'span',attrs,false),on),[_vm._v(" "+_vm._s(_vm.contractor.name)+" ")])]}}])},[_vm._v(" "+_vm._s(_vm.contractor.path)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }